import React from 'react';
import {
  GridColCardContainer,
  GridColCardHeader,
  GridColCardHeaderIcon,
  GridColCardHeaderInfo,
  GridColCardBody,
  GridColCardBodyGrid,
  GridColCardBodyLabel,
  GridColCardBodyValue,
  GridColCardFooter,
  GridColCardFooterLabel,
  GridColCardFooterPrice,
  GridColCardFooterValue,
  GridColCardFooterValueInfo,
  GridColCardFooterButton,
  GridColCardFooterStatus,
  AnularFooterButton,
  GridColCardFooterInvest,
  GridColCardLeftCol,
  GridColCardRightCol
} from './styles';
import { P } from '../Typography/styles';
import { BsPersonCheck, BsArrowRightShort } from 'react-icons/bs';
import { formatData, formatDateToDefaultUS } from '../../helpers/date';
import { formatPrice } from '../../helpers/price';
import { useHistory } from 'react-router-dom';
import colors from '../../assets/styles/colors';
import redirectToCorrectPageCdt from '../../services/redirectToCorrectPageCdt';
import { exceptionStatus } from '../../helpers/enum';

function formatPeriodicity(periodicity) {
  return periodicity;
}

const GridColCard = ({ item, exception, canalEstado, setShowModalAnular, setIdCreditAnular }) => {
  const history = useHistory();

  return (
    <GridColCardContainer id="card">
      <GridColCardHeader>
        {!exception && (
          <GridColCardHeaderIcon>
            <BsPersonCheck size={20} color={colors.bgPrimary} id="person-check-icon" />
          </GridColCardHeaderIcon>
        )}
        <GridColCardHeaderInfo>
          <P bold color={colors.textPrimary}>{item.nombre}</P>
          <P color={colors.textPrimary}> {item.email}</P>
        </GridColCardHeaderInfo>
      </GridColCardHeader>
      <GridColCardBody>
        <GridColCardBodyGrid>
          <GridColCardLeftCol>
          <GridColCardFooterLabel color={colors.textPrimary}>Inversión</GridColCardFooterLabel>
          <GridColCardFooterPrice>
            <GridColCardFooterValue>
              $ {formatPrice(parseFloat(item.monto.balance))}
            </GridColCardFooterValue>
          <GridColCardFooterValueInfo>
            Tasa {formatPeriodicity(item.intereses.tasa)}% MV
          </GridColCardFooterValueInfo>
          </GridColCardFooterPrice>
          </GridColCardLeftCol>
          <GridColCardRightCol>
            <GridColCardBodyLabel>
            Fecha apertura: {formatData(item.fechaCreacion)}
            </GridColCardBodyLabel>
          </GridColCardRightCol>
        </GridColCardBodyGrid>
      </GridColCardBody>
      <GridColCardFooter>
        <GridColCardBodyGrid>
        <GridColCardLeftCol>
            <GridColCardFooterLabel>Ver detalle</GridColCardFooterLabel>
          </GridColCardLeftCol>
          <GridColCardRightCol>
            <GridColCardFooterValueInfo>
        <GridColCardFooterButton id="select-item" onClick={() => redirectToCorrectPageCdt(history, item)}>
            <BsArrowRightShort size={22} color={colors.green} id="plus-icon" />
          </GridColCardFooterButton>
          </GridColCardFooterValueInfo>
        </GridColCardRightCol>
        </GridColCardBodyGrid>
      </GridColCardFooter>
      
      {exception && (
        <GridColCardFooterStatus background={exceptionStatus[exception].background}>
          {exceptionStatus[exception].nombre}
        </GridColCardFooterStatus>
      )}
    </GridColCardContainer>
  )
}

export default GridColCard;
